<template>
    <VMenu v-bind="$attrs" :class="classList" :attach="true" v-on="$listeners">
        <template #activator="data">
            <slot name="activator" v-bind="data" v-on="data.on" />
        </template>
        <slot />
    </VMenu>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-menu';

export default {
    name: 'SrMenu',
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
};
</script>
